import { Text } from "@/components/ui/baseUi/text"
import boxOfferPlanIcon from "@images/illustrations/boxOfferPlanIcon.svg"
import { BoxLeadOffersWrapper } from "@modules/boxLead/components/boxLeadInfo/boxLeadOffersWrapper"
import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { word } from "@modules/core/utils/i18n"
import { MemberOffersWrapperSkeleton } from "@modules/members/memberOffers/components/memberOffersWrapperSkeleton"
import {
  MemberSendOfferModal,
  type MemberSendOfferModalRef,
} from "@modules/members/sendOfferToMember/components/memberSendOfferModal"
import { Suspense, useRef } from "react"

type Props = {
  leadId: string
} & React.ComponentProps<"div">

export function BoxLeadOffersLayout({ leadId, ...props }: Props) {
  const { data: leadDetails } = useBoxLead(leadId)

  const memberSendOfferModal = useRef<MemberSendOfferModalRef>(null)
  const canSendOffer = useBoxStaffPermission(BoxStaffPermissions.SEND_OFFER)

  const handleSendOfferModal = () => {
    memberSendOfferModal.current?.open()
  }

  if (!leadDetails.user?.id) {
    return null
  }

  return (
    <>
      <div className="flex w-full flex-col gap-6 px-5 pt-5 pb-6" {...props}>
        {/* Send offer button */}
        {canSendOffer && (
          <div
            onClick={handleSendOfferModal}
            className="shiny-hover mx-1 flex cursor-pointer items-center justify-center gap-2 rounded-2xl border-2 border-borderPrimary bg-neutral-50 p-2"
          >
            <img src={boxOfferPlanIcon} />
            <Text fontStyle="TS" className="text-textDefault-body">
              {word("box.member.table.offer.menu.sendOffer")}
            </Text>
          </div>
        )}
        <div className="flex w-full border border-solid border-borderDefault" />
        {/* Offers List */}
        <Suspense fallback={<MemberOffersWrapperSkeleton />}>
          <BoxLeadOffersWrapper userId={leadDetails.user.id} />
        </Suspense>
      </div>

      <MemberSendOfferModal
        userId={leadDetails.user.id}
        memberId={leadDetails.boxMemberLight?.boxMemberId}
        isSendingToLead={true}
        ref={memberSendOfferModal}
      />
    </>
  )
}
